<template>
  <div class="columns is-multiline">
    <div class="column is-full">
      <spot-trackers-subscription-task-import
        class="is-right"
        :spot-tracker-subscription-task-groups.sync="spotTrackerSubscriptionTaskGroups"
      />
    </div>
    <div class="column is-full">
      <spot-tracker-subscription-task-group-table
        :spot-trackers="spotTrackers"
        :spot-tracker-subscription-task-groups.sync="spotTrackerSubscriptionTaskGroups"
        :administrators="administrators"
        :loading="loading"
        class="box"
      />
    </div>
  </div>
</template>

<script>
import SpotTrackerSubscriptionTaskGroupTable from './SpotTrackerSubscriptionTaskGroupTable.vue'
import SpotTrackersSubscriptionTaskImport from './SpotTrackersSubscriptionTaskImport.vue'

const LOAD_INTERVAL_IN_SECONDS = 5

export default {
  name: 'ListSpotTrackerSubscriptions',

  components: {
    SpotTrackerSubscriptionTaskGroupTable,
    SpotTrackersSubscriptionTaskImport,
  },

  data() {
    return {
      loading: true,
      spotTrackers: [],
      spotTrackerSubscriptionTaskGroups: [],
      administrators: [],
      loadIntervalId: null,
    }
  },

  async mounted() {
    this.loading = true
    await Promise.all([
      this.fetchSpotTracker(),
      this.fetchAdministrators(),
      this.fetchSpotTrackerSubscriptionTaskGroups(),
    ])
    this.loading = false

    this.startLoadPolling()
  },

  beforeDestroy() {
    this.stopLoadPolling()
  },

  methods: {
    startLoadPolling() {
      this.stopLoadPolling()

      this.loadIntervalId = window.setInterval(async () => {
        await this.fetchSpotTrackerSubscriptionTaskGroups()
      }, LOAD_INTERVAL_IN_SECONDS * 1000)
    },

    stopLoadPolling() {
      if (this.loadIntervalId) {
        window.clearInterval(this.loadIntervalId)
      }
    },

    async fetchSpotTracker() {
      try {
        this.spotTrackers = await this.$services.spotTrackerService.getAll({
          keyword: null,
          availability: null,
          owner: null,
          expired: null,
        })
      } catch (err) {
        console.error(err)
      }
    },

    async fetchAdministrators() {
      try {
        this.administrators = await this.$services.administratorService.getAll()
      } catch (err) {
        console.error(err)
      }
    },

    async fetchSpotTrackerSubscriptionTaskGroups() {
      try {
        this.spotTrackerSubscriptionTaskGroups =
          await this.$services.spotTrackerSubscriptionTaskGroupService.getAll()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
